/**
 * La firma visual del diseño: esquina superior izquierda índigo, inferior
 * derecha coral, cortadas en diagonal. Dos capas y clip-path, sin SVG.
 *
 * Es un ACENTO. En el panel se usa en exactamente tres sitios: la franja
 * de KPIs de Órdenes, la cabecera de Detalle de usuario y la cabecera de
 * país en Logística. El resto de tarjetas usan .ui-card (borde plano).
 */
export const DiagonalCard = ({ children, cut = 26, className = '', style }) => {
  const clip = (c) =>
    `polygon(${c}px 0, 100% 0, 100% calc(100% - ${c}px), calc(100% - ${c}px) 100%, 0 100%, 0 ${c}px)`;

  return (
    <div className="ui-diagonal" style={{ clipPath: clip(cut) }}>
      <div className={`ui-diagonal__inner ${className}`} style={{ ...style, clipPath: clip(cut - 1) }}>
        {children}
      </div>
    </div>
  );
};

export default DiagonalCard;
